module.exports = __webpack_public_path__ + "static/media/number.dfdef743.png";